import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setSetupIntent } from '../features/intentSlice'
import { setMethod } from '../features/paymentSlice'
import { type ISetupIntent, type BaseQueryFnType, type IPaymentMethod } from './types'
import { HEADERS_TITLE } from './constants'
import { PAYMENT_END_POINT } from './endpoints'

const BASE_URL = process.env.REACT_APP_API_URL as string

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set('Accept', 'application/json')
      return headers
    }
  }) as BaseQueryFnType,
  endpoints: (builder) => ({
    setupIntent: builder.mutation({
      query: (credentials) => {
        const { token } = credentials
        return {
          url: PAYMENT_END_POINT.SETUP_INTENT,
          method: 'POST',
          credentials: 'include',
          headers: {
            [HEADERS_TITLE.XSRF]: token
          }
        }
      },
      transformResponse: (res: ISetupIntent) => {
        return res
      },
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setSetupIntent(data))
        } catch (error) {
          // console.error(error)
        }
      }
    }),
    getMethod: builder.mutation({
      query: () => {
        return {
          url: PAYMENT_END_POINT.PAYMENT_METHOD,
          method: 'GET',
          credentials: 'include'
        }
      },
      transformResponse: (res: IPaymentMethod) => {
        return res
      },
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setMethod(data))
        } catch (error) {
          // console.error(error)
        }
      }
    }),
    putMethod: builder.mutation({
      query: (credentials) => {
        const { paymentMethodId, token } = credentials
        return {
          url: PAYMENT_END_POINT.PAYMENT_METHOD,
          method: 'PUT',
          body: { paymentMethodId },
          credentials: 'include',
          headers: {
            [HEADERS_TITLE.XSRF]: token
          }
        }
      }
    })
  })
})

export const {
  useSetupIntentMutation,
  useGetMethodMutation,
  usePutMethodMutation
} = paymentApi
